/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentSelectorModule')
.controller('ContentSelectorController', ['$scope','$translate','$window','MediumEditor','BulbCommentService','BulbSelectBlockExtensionFactory','BulbToolbarExtensionFactory', ContentSelectorController]);

function ContentSelectorController($scope, $translate, $window, MediumEditor, BulbCommentService,
                   BulbSelectBlockExtensionFactory, BulbToolbarExtensionFactory) {

  var that = this;

  var CommentButton = MediumEditor.extensions.button.extend({
    name: 'comment',
    contentDefault: '<b translate>toolbar_comment_content</b>',
    contentFA: '<i class="fa fa-comment"></i>',
    aria: $translate.instant('toolbar_comment_rollover'),
    handleClick: function() {
      BulbCommentService.createCommentThread(that.page.unit, that.editor);
      var toolbar = that.editor.getExtensionByName('toolbar');
      toolbar.hideToolbar();
    }
  });

  this.selectedBlockElement = null;
  this.selectedBlock = null;

  /*
   * @staticToolbar, @stickyToolbar
   * Were used in helping mobile support in medium-editor
   * until issue #1040 is resolved within the project,
   * assume these values to always be false.
   *
   * Issue URL: https://github.com/yabwe/medium-editor/issues/1040
   */
  var staticToolbar = false;
  var stickyToolbar = false;

  this.toolbarExtension = new BulbToolbarExtensionFactory.CreateExtension({
    buttons: [
      'comment'
    ],
    standardizeSelectionStart: true,
    static: staticToolbar,
    sticky: stickyToolbar
  });

  this.selectedBlockElement = null;
  this.selectedBlock = null;
  this.selectBlockExtension = new BulbSelectBlockExtensionFactory.CreateExtension({
    blockSelected: function(element) {
      that.selectedBlockElement = angular.element(element);
      that.selectedBlock = element ? that.page.unit.contentBlocks[element.id] : null;
      $scope.$broadcast('selectionChange', that.selectedBlockElement, that.selectedBlock);
      that.updateToolbar();
    },
    scope: $scope,
    contentEditorCtrl: that
  });

  this.editorOptions = {
    anchor: {
      linkValidation: true
    },
    buttonLabels: 'fontawesome',
    disableEditing: true,
    placeholder: {
      text: ''
    },
    extensions: {
      'comment': new CommentButton(),
      'toolbar': this.toolbarExtension,
      'bulbSelectBlock': this.selectBlockExtension,
      'medium-editor-toolbar-states': new $window.MediumEditorToolbarStates({
        states: {
          default: {
            buttons: ['comment']
          },
          image: {
            buttons: ['comment']
          },
          video: {
            buttons: ['comment']
          },
          attachedFile: {
            buttons: ['comment']
          },
          embed: {
            buttons: [ 'comment']
          }
        },
        attributeName: 'toolbar-state'
      })
    },
    keyboardCommands: true
  };

  this.updateToolbar = function() {
    that.editor.checkSelection();
  };
}


